import * as stylex from "@stylexjs/stylex";
import { breakpoints, layoutAreas } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
const styles = {
    root: {
        kBCFzs: "x1uq3dmu",
        kE3dHu: "x1uhho1l",
        kpe85a: "x1xpa7k",
        $$css: true
    },
    padded: {
        kLKAdn: "x1miatn0 x1njqh84",
        kGO01o: "x1gan7if x1mqllrn",
        $$css: true
    },
    unpadded: {
        kLKAdn: "xexx8yu xgwg3r5",
        kGO01o: "x18d9i69 xsm4mki",
        $$css: true
    }
};
export const Title = ({ padded, children })=>{
    return <h1 {...stylex.props(typography.tera, styles.root, padded ? styles.padded : styles.unpadded)}>{children}</h1>;
};
